export default __webpack_public_path__ + "static/media/meslay.ba08d121.jpg";